import {IconName} from "@fortawesome/pro-regular-svg-icons"

export type VoteType = "accept" | "reject" | "unsure" | "skip"
type VoteValue = {
    icon: IconName,
    colorScheme: string,
    bg: string,
    hover?: string,
    text: string
}

export const voteTypes: Record<VoteType, VoteValue> = {
    accept: {
        icon: "check",
        colorScheme: "green",
        bg: "green.500",
        hover: "green.700",
        text: "Yes"
    },
    reject: {
        icon: "times",
        colorScheme: "red",
        bg: "red.500",
        hover: "red.700",
        text: "No"
    },
    unsure: {
        icon: "question-circle",
        colorScheme: "yellow",
        bg: "yellow.500",
        hover: "yellow.700",
        text: "Unsure"
    },
    skip: {
        icon: "arrow-circle-right",
        colorScheme: "gray",
        bg: "gray.500",
        hover: "gray.700",
        text: "Not Applicable"
    },
}

export type GamePlayStatus = "notStarted" | "started" | "finished"

export const gamePlayStatusEnum: { [K in GamePlayStatus]: { title: string, color: string } } = {
    "notStarted": {
        title: "Not started",
        color: "orange"
    },
    "started": {
        title: "Started",
        color: "blue"
    },
    "finished": {
        title: "Completed",
        color: "green"
    },
}